import { useMemo } from 'react';

import { useGenericSearch } from '@/hooks/useGenericSearch';
import { Statistic } from '@/types';

export const useCustomerIntegrationHealth = () => {
  const query = useGenericSearch({
    query: '#statistic#integration#status#now',
    allTenants: true,
  });

  const dataMap = useMemo(() => {
    const accounts: Statistic[] = query.data?.statistics || [];

    return new Map(
      accounts.map(item => {
        const counts = (item.data?.counts || {}) as Record<string, number>;
        const totalIntegrations = Object.values(counts).reduce(
          (acc, curr) => (acc as number) + (curr as number),
          0
        );
        return [
          item.username,
          {
            healthyIntegrations: counts?.['JP'] || 0,
            totalIntegrations,
          },
        ];
      })
    );
  }, [query.data]);

  return {
    ...query,
    dataMap,
  };
};
